export interface PredefinedAgentTemplate {
  id: string;
  name: string;
  description: string;
  system_prompt: string;
  tools: string[];
  max_iterations: number;
}

export const PREDEFINED_AGENTS: PredefinedAgentTemplate[] = [
  {
    id: "research_agent",
    name: "Research Agent",
    description: "Researches a topic across the web and returns a structured summary",
    system_prompt:
      "You are a thorough research agent. Given a topic or question, search the web using multiple sources, " +
      "cross-reference information, and produce a well-structured, factual summary with key findings. " +
      "Always cite your sources.",
    tools: ["tavily", "jina_reader", "wikipedia"],
    max_iterations: 10,
  },
  {
    id: "seo_content_agent",
    name: "SEO Content Agent",
    description: "Researches top-ranking articles and generates an SEO-optimized content brief",
    system_prompt:
      "You are an SEO content strategist. Given a keyword or topic, research the top-ranking articles, " +
      "identify content gaps and angles, extract common headings and topics, and produce a detailed " +
      "SEO content brief with recommended structure, key points to cover, and target keywords.",
    tools: ["duckduckgo", "jina_reader", "newspaper4k"],
    max_iterations: 12,
  },
  {
    id: "youtube_research_agent",
    name: "YouTube Research Agent",
    description: "Finds top-performing videos on a topic, extracts key patterns and insights",
    system_prompt:
      "You are a YouTube content researcher. Given a topic, search for top-performing videos, " +
      "analyze titles, thumbnails (from metadata), view counts, and engagement patterns. " +
      "Identify what makes the best-performing content successful and provide actionable insights.",
    tools: ["serpapi_youtube", "jina_reader"],
    max_iterations: 8,
  },
  {
    id: "data_analyst_agent",
    name: "Data Analyst Agent",
    description: "Loads a dataset, runs analysis, generates insight narrative",
    system_prompt:
      "You are a data analyst. Given a CSV file or dataset, load it, explore the structure, " +
      "run relevant analyses (distributions, correlations, outliers), and produce a clear " +
      "narrative summary of key insights and patterns found in the data.",
    tools: ["csv", "calculator", "python"],
    max_iterations: 15,
  },
];

export const TOOL_DISPLAY_NAMES: Record<string, string> = {
  duckduckgo: "DuckDuckGo",
  tavily: "Tavily Search",
  wikipedia: "Wikipedia",
  jina_reader: "Jina Reader",
  newspaper4k: "Newspaper",
  calculator: "Calculator",
  python: "Python",
  sleep: "Sleep",
  serpapi_youtube: "YouTube Search",
  csv: "CSV",
};

export const TOOL_GROUPS: { label: string; tools: string[] }[] = [
  {
    label: "Research & Search",
    tools: ["duckduckgo", "tavily", "wikipedia"],
  },
  {
    label: "Web & Reading",
    tools: ["jina_reader", "newspaper4k"],
  },
  {
    label: "Social",
    tools: ["serpapi_youtube"],
  },
  {
    label: "Data & Files",
    tools: ["csv"],
  },
  {
    label: "Utilities",
    tools: ["calculator", "python", "sleep"],
  },
];
